<template>
  <div class="content-example-barra">
    <div class="barra-accesibilidad-govco">
      <button
        :aria-label="
          currentTheme === 'dark' ? 'Desactivar contraste' : 'Activar contraste'
        "
        :aria-pressed="currentTheme === 'dark' ? 'true' : 'false'"
        tabindex="0"
        style="border: none !important"
        id="botoncontraste"
        class="icon-contraste no-ajustar-letra"
        @click="toogleTheme"
      >
        <span id="titlecontraste" class="no-ajustar-letra">Contraste</span>
      </button>
      <button
        aria-label="Reducir tamaño de letra"
        style="border: none !important"
        id="botondisminuir"
        class="icon-reducir no-ajustar-letra"
        @click="decrementFont"
      >
        <span id="titledisminuir" class="no-ajustar-letra">Reducir letra</span>
      </button>
      <button
        aria-label="Aumentar tamaño de letra"
        style="border: none !important"
        id="botonaumentar"
        class="icon-aumentar no-ajustar-letra"
        @click="incrementFont"
      >
        <span id="titleaumentar" class="no-ajustar-letra">Aumentar letra</span>
      </button>
      <button
        aria-label="Ir a Centro de Relevo"
        style="border: none !important"
        id="botonrelevo"
        class="icon-relevo no-ajustar-letra"
        @click="openCentroDeRelevo"
      >
        <span id="titlerelevo" class="no-ajustar-letra">Centro de relevo</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentTheme: localStorage.getItem("theme") || "",
      body: document.getElementsByTagName("body"),
      headingH1: document.getElementsByTagName("h1"),
      headingH2: document.getElementsByTagName("h2"),
      headingH3: document.getElementsByTagName("h3"),
      parragraphs: document.getElementsByTagName("p"),
      labels: document.getElementsByTagName("label"),
      lis: document.getElementsByTagName("li"),
      inputs: document.getElementsByTagName("input"),
      tableRows: document.getElementsByTagName("tr"),
      spans: document.getElementsByTagName("span"),
      anchorTag: document.getElementsByTagName("a"),
      limitSize: null,
    };
  },
  mounted() {
    if (this.currentTheme) {
      this.body[0].classList.add(this.currentTheme);
    }
  },
  methods: {
    /**
     * Toggle between light and dark themes.
     * It updates the localStorage and the body class accordingly
     */
    toogleTheme() {
      if (this.currentTheme === "") {
        this.currentTheme = "dark";
        localStorage.setItem("theme", "dark");
        this.body[0].classList.add("dark");
      } else {
        this.currentTheme = "";
        localStorage.setItem("theme", "");
        this.body[0].classList.remove("dark");
      }
    },
    /**
     *
     * @param tag - HTMLCollection of elements to adjust font size
     * This method checks if the tag is the body element and sets the limitSize
     */
    toTakeGetComputedStyle(tag) {
      if (tag[0] === document.body) {
        const currentFontSize = parseFloat(getComputedStyle(tag[0]).fontSize);
        this.limitSize = currentFontSize;
      }
    },
    /**
     *
     * @param tag - HTMLCollection of elements to decrease font size
     * This method decreases the font size of each element in the tag by 1px
     */
    fontSizeLess(tag) {
      this.toTakeGetComputedStyle(tag);
      if (this.limitSize <= 14) return;
      Array.from(tag).forEach((element) => {
        if (!element.classList.contains("no-ajustar-letra")) {
          element.style.fontSize =
            parseFloat(getComputedStyle(element).fontSize) - 1 + "px";
        }
      });
    },
    /**
     *
     * @param tag - HTMLCollection of elements to increase font size
     * This method increases the font size of each element in the tag by 1px
     */
    fontSizeMore(tag) {
      this.toTakeGetComputedStyle(tag);
      if (this.limitSize >= 20) return;
      Array.from(tag).forEach((element) => {
        if (!element.classList.contains("no-ajustar-letra")) {
          element.style.fontSize =
            parseFloat(getComputedStyle(element).fontSize) + 1 + "px";
        }
      });
    },
    /**
     * Decrease font size for various elements
     * This method applies the fontSizeLess method to multiple HTMLCollections
     */
    decrementFont() {
      this.fontSizeLess(this.body);
      this.fontSizeLess(this.headingH1);
      this.fontSizeLess(this.headingH2);
      this.fontSizeLess(this.headingH3);
      this.fontSizeLess(this.parragraphs);
      this.fontSizeLess(this.labels);
      this.fontSizeLess(this.tableRows);
      this.fontSizeLess(this.spans);
      this.fontSizeLess(this.anchorTag);
      this.fontSizeLess(this.lis);
      this.fontSizeLess(this.inputs);
    },
    /**
     * Increase font size for various elements
     * This method applies the fontSizeMore method to multiple HTMLCollections
     */
    incrementFont() {
      this.fontSizeMore(this.body);
      this.fontSizeMore(this.headingH1);
      this.fontSizeMore(this.headingH2);
      this.fontSizeMore(this.headingH3);
      this.fontSizeMore(this.parragraphs);
      this.fontSizeMore(this.labels);
      this.fontSizeMore(this.tableRows);
      this.fontSizeMore(this.spans);
      this.fontSizeMore(this.anchorTag);
      this.fontSizeMore(this.lis);
      this.fontSizeMore(this.inputs);
    },

    openCentroDeRelevo() {
      window.open(
        "https://centroderelevo.gov.co/632/w3-channel.html",
        "_blank",
      );
    },
  },
  computed: {
    session: function () {
      return this.$store.state.session;
    },
  },
};
</script>

<style>
/***
 * Gov.co (https://www.gov.co) - Gobierno de Colombia
 *  - Componente: barra accesibilidad
 *  - Version: 4.0.0
 */
.govco-adjust {
  background-image: url(../../assets/icons/adjust.svg);
  min-width: 1rem;
  min-height: 1rem;
  display: inline-block;
  background-repeat: no-repeat;
  background-size: 1rem 1rem;
}

/* Fuente iconografica */
@font-face {
  /* font-family: "govco-font";
    src: url("../assets/icons/fonts/govco-font-icons.ttf") format("truetype"); */
  font-weight: normal;
  font-style: normal;
}

/* WorkSans-SemiBold */
@font-face {
  font-family: "Nunito Sans";
  src: url("../../assets/fonts/NunitoSansBold.ttf");
}

/* WorkSans-Regular */
@font-face {
  font-family: "Nunito Sans";
  src: url("../../assets/fonts/NunitoSansRegular.ttf");
}

/* WorkSans-SemiBold */
@font-face {
  font-family: "Nunito Sans";
  src: url("../../assets/fonts/NunitoSansBold.ttf");
}

/* Montserrat-SemiBold */
@font-face {
  font-family: "Nunito Sans";
}

.barra-accesibilidad-govco {
  height: 183px;
  width: 48px;
  position: fixed;
  right: 0;
  top: 35%;
  background-color: #004884 !important;
  border-radius: 10px 0px 0px 10px;
  opacity: 1;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 12px;
  padding-bottom: 20px;
  align-items: center;
}

.barra-accesibilidad-govco button {
  border: none !important;
  line-height: inherit;
}

.barra-accesibilidad-govco .icon-contraste {
  background: #004884;
  width: 48px;
  height: 40px;
  border: none;
  outline: none !important;
  text-decoration: none;
}

.barra-accesibilidad-govco .icon-contraste::after {
  background: #fff url(../../assets/icons/icon-adjust.svg) no-repeat center
    center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
}

.barra-accesibilidad-govco #titlecontraste {
  text-align: left;
  position: absolute;
  background: #3366cc;
  color: #fff;
  line-height: normal !important;
  font-family: "Nunito Sans" !important;
  font-weight: 400 !important;
  font-size: 14px;
  margin-top: -8px;
  opacity: 0;
  width: 172px;
  height: 40px;
  border-radius: 10px 0px 0px 10px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 12px;
}

.barra-accesibilidad-govco button:hover #titlecontraste {
  opacity: 1;
  visibility: visible;
  margin-left: -135px;
}

.icon-contraste:focus {
  border: 3px solid red;
}

.icon-contraste:hover::after {
  background: #fff url(../../assets/icons/icon-adjust.svg) no-repeat center
    center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
  visibility: visible;
}

.icon-contraste:focus #titlecontraste {
  font-family: "Nunito Sans" !important;
  font-weight: 400 !important;
  opacity: 0;
  line-height: normal !important;
  visibility: visible;
  margin-left: -136px;
  outline: 0px solid #000;
  outline-offset: 2px;
}

.icon-contraste:focus::after {
  background: #fff url(../../assets/icons/icon-adjust.svg) no-repeat center
    center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  outline: 4px solid #3366cc !important;
  outline-offset: 4px !important;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
}

.barra-accesibilidad-govco .icon-reducir {
  background: #004884;
  text-align: center;
  width: 48px;
  height: 40px;
  border: none;
  outline: none !important;
  text-decoration: none;
}

.barra-accesibilidad-govco .icon-reducir::after {
  background: #fff url(../../assets/icons/icon-font-minimize.svg) no-repeat
    center center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
}

.barra-accesibilidad-govco #titledisminuir {
  text-align: left;
  position: absolute;
  background: #3366cc;
  color: #fff;
  line-height: normal !important;
  font-family: "Nunito Sans" !important;
  font-weight: 400 !important;
  font-size: 14px;
  margin-top: -8px;
  opacity: 0;
  width: 172px;
  height: 40px;
  border-radius: 10px 0 0 10px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 12px;
}

.barra-accesibilidad-govco button:hover #titledisminuir {
  opacity: 1;
  visibility: visible;
  margin-left: -135px;
}

.icon-reducir:hover::after {
  background: #fff url(../../assets/icons/icon-font-minimize.svg) no-repeat
    center center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
  visibility: visible;
}

.icon-reducir:focus #titledisminuir {
  font-family: "Nunito Sans" !important;
  font-weight: 400 !important;
  opacity: 0;
  line-height: normal !important;
  visibility: visible;
  margin-left: -136px;
  outline: 0px solid #000;
  outline-offset: 2px;
}

.icon-reducir:focus::after {
  background: #fff url(../../assets/icons/icon-font-minimize.svg) no-repeat
    center center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  outline: 4px solid #3366cc !important;
  outline-offset: 4px !important;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
}

.barra-accesibilidad-govco .icon-aumentar {
  background: #004884;
  text-align: center;
  width: 48px;
  height: 40px;
  border: none;
  outline: none !important;
  text-decoration: none;
}

.barra-accesibilidad-govco .icon-aumentar::after {
  background: #fff url(../../assets/icons/icon-font-maximize.svg) no-repeat
    center center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
}

.barra-accesibilidad-govco .icon-relevo {
  background: #004884;
  text-align: center;
  width: 48px;
  height: 40px;
  border: none;
  outline: none !important;
  text-decoration: none;
}

.barra-accesibilidad-govco .icon-relevo::after {
  background: #fff url(../../assets/icons/icon-relief.svg) no-repeat center
    center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
}

.barra-accesibilidad-govco button:hover #titleaumentar {
  opacity: 1;
  visibility: visible;
  margin-left: -135px;
}

.barra-accesibilidad-govco #titleaumentar {
  text-align: left;
  position: absolute;
  background: #3366cc;
  color: #fff;
  line-height: normal !important;
  font-family: "Nunito Sans" !important;
  font-weight: 400 !important;
  font-size: 14px;
  margin-top: -8px;
  opacity: 0;
  width: 172px;
  height: 40px;
  border-radius: 10px 0 0 10px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 12px;
}

.barra-accesibilidad-govco button:hover #titlerelevo {
  opacity: 1;
  visibility: visible;
  margin-left: -135px;
}

.barra-accesibilidad-govco #titlerelevo {
  text-align: left;
  position: absolute;
  background: #3366cc;
  color: #fff;
  line-height: normal !important;
  font-family: "Nunito Sans" !important;
  font-weight: 400 !important;
  font-size: 14px;
  margin-top: -8px;
  opacity: 0;
  width: 172px;
  height: 40px;
  border-radius: 10px 0 0 10px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 12px;
}

.icon-relevo:hover::after {
  background: #fff url(../../assets/icons/icon-relief.svg) no-repeat center
    center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
  visibility: visible;
}

.icon-aumentar:hover::after {
  background: #fff url(../../assets/icons/icon-font-maximize.svg) no-repeat
    center center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
  visibility: visible;
}

.icon-aumentar:focus #titleaumentar {
  font-family: "Nunito Sans" !important;
  font-weight: 400 !important;
  opacity: 0;
  line-height: normal !important;
  visibility: none;
  margin-left: -136px;
  outline: 0px solid #000;
  outline-offset: 0px;
}

.icon-aumentar:focus::after {
  background: #fff url(../../assets/icons/icon-font-maximize.svg) no-repeat
    center center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  outline: 4px solid #3366cc !important;
  outline-offset: 4px !important;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
}

.icon-relevo:focus #titlerelevo {
  font-family: "Nunito Sans" !important;
  font-weight: 400 !important;
  opacity: 0;
  line-height: normal !important;
  visibility: none;
  margin-left: -136px;
  outline: 0px solid #000;
  outline-offset: 0px;
}

.icon-relevo:focus::after {
  background: #fff url(../../assets/icons/icon-relief.svg) no-repeat center
    center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  outline: 4px solid #3366cc !important;
  outline-offset: 4px !important;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
}

.active-barra-accesibilidad-govco {
  background-color: #3366cc !important;
}

.active-barra-accesibilidad-govco.icon-relevo::after {
  background: #fff url(../../assets/icons/icon-relief.svg) no-repeat center
    center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
}

.active-barra-accesibilidad-govco.icon-aumentar::after {
  background: #fff url(../../assets/icons/icon-font-maximize.svg) no-repeat
    center center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
}

.active-barra-accesibilidad-govco.icon-reducir::after {
  background: #fff url(../../assets/icons/icon-font-minimize.svg) no-repeat
    center center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
}

.active-barra-accesibilidad-govco.icon-contraste::after {
  background: #fff url(../../assets/icons/adjust.svg) no-repeat center center;
  background-size: 22px 18px;
  content: "";
  height: 24px;
  width: 24px;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 5px;
  opacity: 1;
  position: relative;
}

.modo_oscuro-govco {
  width: 100%;
  align-items: center;
  text-align: center;
  background-color: #000;
  color: #fff;
}

.modo_oscuro-govco .titulo-barra-accesibilidad {
  font-family: Montserrat-SemiBold;
  font-size: 20px;
  margin: 0px;
}

.modo_oscuro-govco .descripcion-barra-accesibilidad {
  font-family: WorkSans-Regular;
  font-size: 16px;
  margin: 0px;
}

.modo_claro-govco {
  width: 100%;
  align-items: center;
  text-align: center;
  background-color: #fff;
}

.modo_claro-govco .titulo-barra-accesibilidad {
  color: #000;
  font-family: Montserrat-SemiBold;
  font-size: 20px;
  margin: 0px;
}

.modo_claro-govco .descripcion-barra-accesibilidad {
  color: #4b4b4b;
  font-family: WorkSans-Regular;
  font-size: 16px;
  margin: 0px;
}

.no-ajustar-letra {
  font-size: 15px !important;
}

.barra-accesibilidad-govco button:focus {
  outline: 2px solid #3366cc;
  outline-offset: 2px;
}

.barra-accesibilidad-govco button:focus #titlecontraste {
  opacity: 1;
  visibility: visible;
  margin-left: -135px;
}
.barra-accesibilidad-govco button:focus #titleaumentar {
  opacity: 1;
  visibility: visible;
  margin-left: -135px;
}
.barra-accesibilidad-govco button:focus #titledisminuir {
  opacity: 1;
  visibility: visible;
  margin-left: -135px;
}
.barra-accesibilidad-govco button:focus #titlerelevo {
  opacity: 1;
  visibility: visible;
  margin-left: -135px;
}
</style>
